import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "./styles/global.css";
import { App } from "./App";
import { startOppdateringsvakt } from "./state/oppdatering";

const rot = document.getElementById("root");
if (rot === null) throw new Error("Fant ikke #root");
createRoot(rot).render(<StrictMode><App /></StrictMode>);

/* Holder oeye med nye versjoner. Flata staar aapen i timer paa et sett, og
   en fane som kjoerer gammel kode skal si fra. Se state/oppdatering.ts. */
startOppdateringsvakt();
